/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Who_Word2Inputs */

const en_wc_vs_who_word2 = /** @type {(inputs: Wc_Vs_Who_Word2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`depend on VBA macros, complex templates or SmartArt`)
};

/**
* | output |
* | --- |
* | "depend on VBA macros, complex templates or SmartArt" |
*
* @param {Wc_Vs_Who_Word2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_who_word2 = /** @type {((inputs?: Wc_Vs_Who_Word2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Who_Word2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_who_word2(inputs)
});
export { wc_vs_who_word2 as "wc.vs.who_word2" }